import Vue from 'vue';
import { MutationTree } from 'vuex';
import { BulkJobState } from '../types';

export const mutations: MutationTree<BulkJobState> = {
	SET_ACTIVE_JOB(state: BulkJobState, job: BulkJob | null): void {
		Vue.set(state, 'activeJob', job);
	},

	SET_HISTORY(state: BulkJobState, jobs: BulkJob[]): void {
		Vue.set(state, 'jobHistory', jobs);
	},

	SET_HISTORY_COUNT(state: BulkJobState, count: number): void {
		Vue.set(state, 'jobHistoryCount', count);
	},

	SET_HISTORY_FILTERS(state: BulkJobState, filters: TableFilterParams): void {
		Vue.set(state, 'jobHistoryFilters', filters);
	},

	SET_POLL_INTERVAL_ID(state: BulkJobState, intervalId: number | null): void {
		Vue.set(state, 'pollIntervalId', intervalId);
	},

	CLEAR_ACTIVE_JOB(state: BulkJobState): void {
		Vue.set(state, 'activeJob', null);
	},

	SET_VIEWED_JOB(state: BulkJobState, job: BulkJob | null): void {
		Vue.set(state, 'viewedJob', job);
	}
};
